var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-btn pointer white flex items-center justify-center",class:_vm.className},[_vm._t("prefix"),_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("suffix")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }